// extracted by mini-css-extract-plugin
export var cardLayout = "_62-1";
export var paginationContainer = "_62-0";